export default __webpack_public_path__ + "office_01.jpg?097f91274553d92e5f89125d398f4e1f";